import { render, staticRenderFns } from "./configurationValue-edit.vue?vue&type=template&id=b88679fa&scoped=true"
import script from "./configurationValue-edit.vue?vue&type=script&lang=ts"
export * from "./configurationValue-edit.vue?vue&type=script&lang=ts"
import style0 from "./configurationValue-edit.vue?vue&type=style&index=0&id=b88679fa&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b88679fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b88679fa')) {
      api.createRecord('b88679fa', component.options)
    } else {
      api.reload('b88679fa', component.options)
    }
    module.hot.accept("./configurationValue-edit.vue?vue&type=template&id=b88679fa&scoped=true", function () {
      api.rerender('b88679fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/configuration/configurationValue-edit.vue"
export default component.exports